export default __webpack_public_path__ + "static/media/about-transformation-pic.a5823f78.png";